import React from 'react';
import PropTypes from 'prop-types';

import withIntl from '../../../lib/withIntl';

import './LabwareList.scss';

const LabwareList = React.forwardRef(({children, intl}, ref) => (
  <div ref={ref} className="labware-list">
    <span className="labware-list-header">{intl.formatMessage({id: 'protocolEditor.labwareList.header'})}</span>
    <div className="separator" />
    <span className="labware-list-instruction">
      {intl.formatMessage({id: 'protocolEditor.labwareList.instruction'})}
    </span>
    <div className="labware-list-content block-scrollable">{children}</div>
  </div>
));

LabwareList.propTypes = {
  children: PropTypes.any,
  intl: PropTypes.any.isRequired,
};

LabwareList.defaultProps = {
  children: null,
};

export default withIntl(LabwareList);
